import Page from "@/shared/page";
import { EditorConfigProvider } from "./model/config/provider";
import { Config } from "./model/config/types";
import { EntityAttributesProvider } from "./model/entity-attributes/provider";
import { SelectedGroupProvider } from "./model/selected-group/provider";
import { EditorAttributesList } from "./ui/attributes-list";
import { EditorHead } from "./ui/editor-head";
import { GroupSelect } from "./ui/group-select";
import { Options } from "./ui/options";

type EditorProps = { config: Config };

export function Editor({ config }: EditorProps) {
  return (
    <EditorConfigProvider config={config}>
      <EntityAttributesProvider>
        <SelectedGroupProvider>
          <Page.Grid>
            <EditorHead
              entityName={config.entity}
              groupSelector={<GroupSelect />}
              options={<Options />}
            />
            <EditorAttributesList />
          </Page.Grid>
        </SelectedGroupProvider>
      </EntityAttributesProvider>
    </EditorConfigProvider>
  );
}
